import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ResumenIntentosModel } from '../../../../../model/Etapas.model';

@Component({
  selector: 'app-modal-resumen-intentos',
  templateUrl: './modal-resumen-intentos.component.html',
  styleUrls: ['./modal-resumen-intentos.component.css']
})
export class ModalResumenIntentosComponent implements OnInit {
  resumenIntentos = new Array<ResumenIntentosModel>();
  displayedColumns=[];
  dataSource = new Array<ResumenIntentosModel>();
  columnNames = [
    { id: 'intento', value: 'intento' },
    { id: 'correctas', value: 'correctas' },
    { id: 'cantidad', value: 'cantidad' },
    { id: 'estado', value: 'estado' },
    { id: 'porcentaje',  value: 'estamento.porcentaje' }, 
  ];
  constructor(
    public dialogRef: MatDialogRef<ModalResumenIntentosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.resumenIntentos = this.data.dataResumen;

    this.llenarResumen();
  }

  onNoClick(){
    this.dialogRef.close();
  }

  llenarResumen(){
    this.displayedColumns = this.columnNames.map(x => x.id);
    this.dataSource = this.resumenIntentos;
  }
}
